const MediaDomain = Object.freeze({
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE',
  TIKTOK: 'TIKTOK',
  PODCAST: 'PODCAST'
})
export default MediaDomain
export type MediaDomainStrings = typeof MediaDomain[keyof typeof MediaDomain]
// RESERVE BELOW
